import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { Result, mappingResultError } from '@digibricks/core';
import { EXAMINATION_ASSIGNMENT_REPOSITORY } from '../../core';
import { EXAMINATION_ASSIGNMENT_API } from '../data-sources';
import { AssignmentMapper } from './assignment.mapper';
export var ExaminationAssignmentRepository = /*#__PURE__*/function () {
  function ExaminationAssignmentRepository(examinationAssignmentApi, assignmentMapper) {
    _classCallCheck(this, ExaminationAssignmentRepository);

    this.examinationAssignmentApi = examinationAssignmentApi;
    this.assignmentMapper = assignmentMapper;
  }

  _createClass(ExaminationAssignmentRepository, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var responseOrError, responseDto, createAssignmentResponseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.examinationAssignmentApi.create(input);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                responseDto = responseOrError.getValue();
                createAssignmentResponseOrError = this.assignmentMapper.toDomain(responseDto);

                if (!createAssignmentResponseOrError.isFailure) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", mappingResultError(createAssignmentResponseOrError));

              case 9:
                return _context.abrupt("return", Result.ok(createAssignmentResponseOrError.getValue()));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return ExaminationAssignmentRepository;
}();
export var examinationAssignmentRepositoryProvider = {
  provide: EXAMINATION_ASSIGNMENT_REPOSITORY,
  useFactory: function useFactory(examinationAssignmentApi, mapper) {
    return new ExaminationAssignmentRepository(examinationAssignmentApi, mapper);
  },
  inject: [EXAMINATION_ASSIGNMENT_API, AssignmentMapper]
};